// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2ENA-","signatureButtonsRight":"ModalSign_signatureButtonsRight__3wJaQ"};